exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-fluid {\n  padding-bottom: 0px !important;\n}\n\n.pb-40 {\n  padding-bottom: 40px;\n}", ""]);

